import * as React from 'react';
import { connect } from 'react-redux';

import BaseReportingPage from '../base/BaseReportingPage';
import CampaignReportMetrics from 'modules/campaigns/components/campaign-report/metrics/CampaignReportMetrics';
import PageHeading from 'components/page/page-heading/PageHeading';
import ActionLink from 'components/buttons/action-link/ActionLink';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./content-metrics-page.i18n.json'));

import './content-metrics-page.scss';

import type { Campaign, LocationWindow, Params } from 'types';

type StateProps = {
  campaign: Campaign
};

type OwnProps = {
  params: Params,
  location: LocationWindow
};

type Props = OwnProps & StateProps;

const ContentMetricsPage = (
  {
    params,
    location,
    campaign
  }: Props
): JSX.Element => (
  <BaseReportingPage
    headline={__t('content_metrics_page.page_headline')}
    params={params}
  >
    <div className="content-metrics-page__heading">
      <PageHeading
        heading={__t('content_metrics_page.page_heading')}
        color="light"
        size="h1"
        margin="none"
      />
      <div className="content-metrics-page__help-link">
        {__t('content_metrics_page.how_i_estimate')}&nbsp;
        <ActionLink
          color="secondary"
          link="https://help.collabary.com/en/articles/5201299-content-metrics-how-do-i-use-estimates"
        >
          {__t('content_metrics_page.learn_more_link')}
        </ActionLink>
      </div>
    </div>
    {
      campaign && campaign.id && (
        <CampaignReportMetrics
          campaignId={campaign.id}
          location={location}
          isFullscreen={false}
        />
      )
    }
  </BaseReportingPage>
);

const mapStateToProps = ({ campaignBrief }): StateProps => ({
  campaign: campaignBrief.brief
});

export default connect(mapStateToProps)(ContentMetricsPage);
